import styled from "styled-components";

export const Root = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100vh;
`

export const ContentWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 25px;
`
